module.exports = __webpack_public_path__ + "media/images/custom_page/ab6ix_event/ab6ix-event-ko-6739bacf4bd70d388917146636e5c5a1.png";